<div class="actions">
  <app-title-large color="var(--color-neutral-40)" [paddingMobile]="true">{{
    "MyClaims" | translate
  }}</app-title-large>

  <div>
    <app-os-actions-case
      *ngIf="claim; else NoClaimTemplate"
      [claim]="claim"
      [showDetails]="true"
    ></app-os-actions-case>

    <ng-template #NoClaimTemplate>
      <div class="spin-container">
        <mat-spinner [mode]="'indeterminate'" diameter="60"></mat-spinner>
      </div>
    </ng-template>
  </div>
</div>
